export default (scroller) => {
    
    let bannerStatement = document.querySelector(".banner-statement");
    let closeBtn = bannerStatement.querySelector(".close-banner");

    if (bannerStatement) {
      closeBtn.addEventListener("click", () => {
        bannerStatement.remove();

        setTimeout(() => {
          scroller.update();
        }, 600);
      })
    }
 


    let cookieDaysLifeTime = 30;
    let cookiePopup = document.querySelector(".cookies-wrapper");
   

    function getCookie(name) {
      let value = "; " + document.cookie;
      let parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    if (cookiePopup) {
      
      let cookieVal = getCookie("cookiesPolicy");
      let acceptBtn = cookiePopup.querySelector(".accept");
      let declineBtn = cookiePopup.querySelector(".decline");
      let closeBtn = cookiePopup.querySelector(".close-cookie");
      if (cookieVal !== "accepted") {
        cookiePopup.classList.add("cookies-wrapper--visible");
        
      }
      if (acceptBtn) {
        acceptBtn.addEventListener("click", function () {
          cookiePopup.classList.toggle("cookies-wrapper--visible");

          setCookie("cookiesPolicy", "accepted", cookieDaysLifeTime);
        });
        declineBtn.addEventListener("click", function () {
          cookiePopup.classList.toggle("cookies-wrapper--visible");
        });
        closeBtn.addEventListener("click", function () {
          
          cookiePopup.classList.toggle("cookies-wrapper--visible");
        });
      }
    }

   
  
};